<template>
	<h1>Hello World</h1>
</template>

<script>
	export default {
		name: 'hello',
		data() {
			return {
				msg: 'Welcome to Your Vue.js App'
			}
		},
		//计算数据
		computed: {},
		//参数数据
		props: {},
		//方法
		methods: {},
		//组件
		components: {},
		//生命周期-创建
		created() {},
		//生命周期-准备就绪
		mounted() {},
		//监控变量
		watch: {}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	@import url("../assets/common.less");

</style>


// WEBPACK FOOTER //
// Hello.vue?0a6adecc